import React from 'react';
import { FooterContainer } from './style.js';

const Footer = () => {
    return(
        <FooterContainer>
            <h3>
                Handcrafted by me © 2021
            </h3>
        </FooterContainer>
    );
}

export default Footer;